import SockJS from "sockjs-client/dist/sockjs.min";
import { Client } from "@stomp/stompjs";

let stompClient = null;

/**
 * Abonniert die Termin-Änderungen des Standorts. Der Callback bekommt das Signal
 * ({ action, eventId, clientId }) und laedt die Termine selbst nach.
 */
export function connectCalendarSocket(locationId, onCalendarUpdate) {
  if (!locationId) return;

  const token = document.querySelector('meta[name="_csrf"]');
  const header = document.querySelector('meta[name="_csrf_header"]');

  try {
    const socket = new SockJS("/ws", null, {
      transports: ["websocket"],
    });

    stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      connectHeaders:
        header && token
          ? {
              [header.content]: token.content,
            }
          : {},
      onConnect: () => {
        stompClient.subscribe(`/topic/calendar/${locationId}`, (message) => {
          try {
            onCalendarUpdate(JSON.parse(message.body));
          } catch (e) {
            console.error("[Kalender] Fehler beim Verarbeiten der Nachricht:", e);
          }
        });
      },
      onStompError: (frame) => {
        console.error("[Kalender] Fehler:", frame.headers["message"]);
      },
      onWebSocketError: (event) => {
        console.error("[Kalender] WebSocket-Fehler:", event);
      },
    });

    stompClient.activate();
  } catch (error) {
    console.error("[Kalender] Fehler beim Verbinden:", error);
  }
}

export function disconnectCalendarSocket() {
  if (stompClient) {
    stompClient.deactivate();
    stompClient = null;
  }
}
